import {
  createStyles,
  Divider,
  List,
  Theme,
  WithStyles,
  withStyles,
  CssBaseline,
  CardContent,
  MenuItem,
  ListItemAvatar,
  ListItem,
  Avatar,
  ListItemText,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as React from "react";
import SimpleListMenu from "./SimpleListMenu";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { ORITATIONS } from "../constants/constants";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 10,
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    card: {
      width: 400,
    },
    listSection: {
      backgroundColor: "inherit",
    },
    img: {
      marginLeft: 20,
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
    },
    image: {
      width: 150,
      height: 150,
    },
    margin: {
      margin: theme.spacing(1),
    },
    cover: {
      width: 151,
      height: 151,
    },
    ul: {
      backgroundColor: "white",
      padding: 0,
    },
    content: {
      flex: "1 0 auto",
    },
    details: {
      display: "flex",
      flexDirection: "column",
    },
    media: {
      height: 140,
    },
    typography: {
      padding: theme.spacing(2),
    },
  });
//   companyData: any;
//   onClick: any;
//   onUpdatePage: any;

interface Props extends WithStyles<typeof styles> {
  formsInputItems: any;
  editData: any;
  key: any;
  index: any;
  onEdit: any;
  onDelete: any;
}
class FormsCardComponent extends React.Component<Props> {
  state = {
    openConfirmationDialog: false,
    isSuccess: false,
    base64: "",
    isError: false,
    open: false,
  };

  componentDidMount = () => {};

  componentDidUpdate = (prevProps: any, prevState: any) => {};

  onMenuOpen = () => {
    this.setState({ open: true });
  };

  handleMenuItemClick = (event: any, index: any) => {
    switch (index) {
      case 0:
        this.props.onEdit(this.props.formsInputItems, this.props.index);
        break;
      case 1:
        this.props.onDelete(this.props.formsInputItems, this.props.index);
        break;
      default: {
        console.log("Oops something happen.");
      }
    }
  };
  getMenuOptions = () => {
    let options = [
      {
        title: "Edit",
        icon: <EditIcon fontSize="small" style={{ marginRight: 10 }} />,
      },
      {
        title: "Delete",
        icon: <DeleteIcon fontSize="small" style={{ marginRight: 10 }} />,
      },
    ];
    return options;
  };
  renderMenuItem = (
    option: any,
    index: any,
    selectedIndex: any,
    onClose: Function
  ) => {
    return (
      <MenuItem
        key={option.title}
        selected={index === selectedIndex}
        onClick={(event) => {
          onClose();
          this.handleMenuItemClick(event, index);
        }}
      >
        {option.icon}
        {option.title}
      </MenuItem>
    );
  };

  render() {
    const { classes, formsInputItems, key } = this.props;
    return (
      <React.Fragment key={key}>
        <CssBaseline />
        <Card className={classes.root}>
          <div
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              display: "flex",
            }}
          >
            {
              <SimpleListMenu
                oritation={ORITATIONS.HORIZONTAL}
                options={this.getMenuOptions()}
                renderItem={this.renderMenuItem}
              />
            }
          </div>
          <Divider />
          <CardContent>
            <List dense={true}>
              {formsInputItems.map((item: any, index: any) => {
                return (
                  <div key={`item-card-${index.toString()}`}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>{item.usedAsSearch ? "SE" : "NS"}</Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.formsInput}
                        secondary={`${item.responseType} SE/NS(Search Enabled/No Search)`}
                      />
                    </ListItem>
                    <Divider />
                  </div>
                );
              })}
            </List>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(FormsCardComponent);
